import reducers from "./EkgReviewReducers";

export default reducers;
